import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_hazardous_substances_are_wrkrs_exposed'

export const dataPointDefinition = {
  retracedId: 'which_hazardous_substances_are_wrkrs_exposed',
  name: 'Which hazardous substances are workers exposed to?',
  description:
    'Hazardous substances mean chemicals that affect reproduction or cause birth defects, or if they are cancer-causing, irritants, allergenic, toxic, flammable, explosive, oxidizing, dangerously reactive, or corrosive.\r\r\n\r\r\nExamples of hazardous substances in apparel and footwear: potassium permanganate (for denim finishing), DMF-solvent (for fake leather production), tetrachloroethylene (PERC) (for dry cleaning).',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-che-12',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15190,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
